import { p as K, m as q, j as e, c as Q, t as X, e as $, d as Y, f as Z, z as I } from "./index-5HZ18Wug.js";
import { styled as c, css as t, ThemeContext as oo, ThemeProvider as B, keyframes as no } from "styled-components";
import { j as x, e as T, p as b, u as to, a as d, s as p, r as a, c as r, d as n, B as h, o as F, T as E, t as eo } from "./style-V_Aar-SK.js";
import { u as io } from "./useMetaContent-M9Eg3hyC.js";
import { useContext as ro, forwardRef as ao } from "react";
import { u as so } from "./useTransitionState-9D4Z4_FK.js";
const lo = {
  xs: 16,
  sm: 24,
  lg: 32,
  xl: 56
}, co = c.div`
  display: inline-flex;
  position: relative;
  pointer-events: none;
  ${K}
  ${q}
`, W = (o) => {
  const i = typeof o == "number" ? o : lo[o];
  return p(a(i));
}, po = c.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: ${x("fill, stroke", T.shortest)};
  vertical-align: middle;
  color: ${({ $color: o }) => o};

  /* Fill the stroke only in case the icon has selected flag */
  ${({ $selected: o }) => o && t`
      .chr-icon__fill-area {
        fill: currentcolor;
        ${b(t`
          fill: WindowText;
        `)}
      }
    `}

  /*
    Fix icon colors in high contrast mode for multiple browsers
    The color is taken dynamically and the icon always visible
    Using system colors - https://adrianroselli.com/2021/02/whcm-and-system-colors.html#CSS2
  */
  ${b(t`
    .chr-icon {
      &__fill--dark {
        fill: WindowText;
      }

      &__stroke--dark {
        stroke: WindowText;
      }
    }
  `)}

${({ $rotation: o }) => o && t`
      ${to(o)}
    `}${x("transform", T.shorter)}

  /* Set width & height for all icon sizes */
  svg {
    ${({ $size: o = "sm" }) => {
  if (o)
    return typeof o == "number" || typeof o == "string" ? W(o) : Object.entries(o).map(
      ([i, l]) => d(i, W(l))
    );
}}
  }

  .chr-icon__fill {
    &--light {
      fill: transparent;
    }

    &--dark {
      fill: currentcolor;
    }
  }

  .chr-icon__stroke {
    &--light {
      stroke: transparent;
    }

    &--dark {
      stroke: currentcolor;
    }
  }
`, ho = ({ icon: o, children: i, className: l, size: s, rotation: g, color: v, selected: C, ...u }) => {
  const S = o;
  return /* @__PURE__ */ e.jsxs(co, { "data-qa": "icon", className: l, ...u, children: [
    /* @__PURE__ */ e.jsx(po, { $size: s, $rotation: g, $color: v, $selected: C, children: /* @__PURE__ */ e.jsx(S, {}) }),
    i
  ] });
}, _ = c.div`
  ${Q}
`;
c.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $size: o = 150 }) => t`
    width: ${o}px;
    height: ${o}px;
  `}

  ${X({
  dark: t`
      background-color: ${r.black};
    `,
  grey: t`
      background-color: ${r.grey};
    `,
  light: t`
      background-color: ${r.white};
    `
})}
`;
const $o = ({ theme: o, children: i }) => {
  const l = ro(oo);
  return o ? /* @__PURE__ */ e.jsx(B, { theme: { theme: o }, children: /* @__PURE__ */ e.jsx(_, { "data-qa": "theme", children: i }) }) : l ? /* @__PURE__ */ e.jsx(e.Fragment, { children: i }) : /* @__PURE__ */ e.jsx(B, { theme: { theme: "light" }, children: /* @__PURE__ */ e.jsx(_, { "data-qa": "theme", children: i }) });
}, k = t`
  ${b(t`
    & > span {
      visibility: hidden;
    }

    &:hover {
      color: WindowText;
      ${n("background-color", "dominantAlpha80")}
    }
  `)}
`, j = t`
  ${b(t`
    forced-color-adjust: preserve-parent-color;
    ${n("border-color", "dominantAlpha60")}
    opacity: 0.7;

    &:hover,
    &:active {
      ${n("color", "accent")}
      background-color: transparent !important;
    }
  `)}
`, A = c.div`
  display: inline-flex;
  margin-right: ${a($.spacer2)};

  &:only-child {
    /* Avoid margin if there are no siblings */
    margin: 0;
  }
`, mo = c.span`
  &:empty {
    /* Avoid margin if no text is present by hiding the element */
    display: none;
  }

  &:only-child {
    /* Avoid margin if there are no siblings */
    margin: 0;
  }
`, uo = {
  active: t`
    ${n("color", "dominant")}
    ${n("box-shadow", "dominantAlpha10", "inset 0 0 0 1px")}

    &:hover {
      ${n("box-shadow", "dominantAlpha80", "inset 0 0 0 1px")}
    }

    &:active {
      ${n("box-shadow", "dominantAlpha10", "inset 0 0 0 1px")}
    }
  `,
  disabled: t`
    cursor: not-allowed;

    /* Disabled button has no interactive states */
    ${n("color", "dominantAlpha40")}
    ${n("box-shadow", "dominantAlpha10", "inset 0 0 0 1px")}

    &:hover,
    &:active {
      ${n("color", "dominantAlpha40")}
      ${n("box-shadow", "dominantAlpha10", "inset 0 0 0 1px")}
    }

    ${j}
  `,
  loading: t`
    ${n("color", "dominantAlpha10")}
    ${n("box-shadow", "dominantAlpha10", "inset 0 0 0 1px")}

    &:hover,
    &:active {
      ${n("color", "dominantAlpha10")}
      ${n("box-shadow", "dominantAlpha10", "inset 0 0 0 1px")}
    }

    ${k}
  `
}, f = t`
  margin: 0;
  border: none;
  box-shadow: none;
  background: none;
  padding: 0;
  ${d(
  h.xl,
  t`
      padding: 0;
    `
)}
`, bo = {
  active: t`
    ${f}
    ${n("color", "dominant")}
  `,
  disabled: t`
    cursor: not-allowed;

    /* Disabled button has no interactive states */
    ${f}
    ${n("color", "dominantAlpha40")}

    &:hover,
    &:active {
      ${f}
      ${n("color", "dominantAlpha40")}
    }

    ${j}
  `,
  loading: t`
    position: relative;
    ${f}
    ${n("color", "dominantAlpha10")}
      filter: brightness(0.9);

    &:hover,
    &:active {
      ${f}
      ${n("color", "dominantAlpha10")}
      filter: brightness(0.9);
    }

    ${k}
  `
}, go = {
  active: t`
    ${n("color", "accent")}
    ${n("background-color", "dominant")}

    &:hover {
      ${n("background-color", "dominantAlpha80")}
    }

    &:active {
      ${n("background-color", "dominantAlpha60")}
    }
  `,
  disabled: t`
    cursor: not-allowed;

    /* Disabled button has no interactive states */
    box-shadow: none;
    ${n("color", "dominantAlpha40")}
    ${n("background-color", "dominantAlpha10")}

    &:hover,
    &:active {
      box-shadow: none;
      ${n("color", "dominantAlpha40")}
      ${n("background-color", "dominantAlpha10")}
    }

    ${j}
  `,
  loading: t`
    position: relative;

    ${n("color", "dominantAlpha10")}
    ${n("background-color", "dominantAlpha10")}

    &:hover,
    &:active {
      ${n("color", "dominantAlpha10")}
      ${n("background-color", "dominantAlpha10")}
    }

    ${k}
  `
}, y = t`
  border: none;
  box-shadow: none;
  background: none;
`, xo = {
  active: t`
    ${y}
    ${n("color", "dominant")}

    &:hover {
      ${n("color", "dominantAlpha80")}
    }

    &:active {
      ${n("color", "dominantAlpha60")}
    }
  `,
  disabled: t`
    cursor: not-allowed !important;

    /* Disabled button has no interactive states */
    ${y}
    ${n("color", "dominantAlpha40")}

    &:hover,
    &:active {
      ${y}
      ${n("color", "dominantAlpha40")}
    }

    ${j}
  `,
  loading: t`
    position: relative;

    ${y}
    ${n("color", "dominantAlpha10")}

    &:hover,
    &:active {
      ${y}
      ${n("color", "dominantAlpha10")}
    }

    ${k}
  `
}, w = t`
  ${F(E.bodySMedium)}

  padding: 0;
  text-transform: unset;
  text-decoration: underline;

  ${d(
  h.xl,
  t`
      padding: 0;
    `
)}
`, vo = {
  active: t`
    ${w}
    ${n("color", "dominant")}

    &:hover,
    &:focus {
      filter: brightness(0.9);
    }

    &:focus {
      text-decoration: underline;
    }

    &:hover {
      text-decoration: none;
    }

    &:active {
      filter: brightness(0.95);
      text-decoration: none;
    }
  `,
  disabled: t`
    cursor: not-allowed;

    /* Disabled button has no interactive states */
    ${w}
    ${n("color", "dominantAlpha40")}

    &:hover,
    &:active {
      ${w}
      ${n("color", "dominantAlpha40")}
    }

    ${j}
  `,
  loading: t`
    position: relative;
    filter: brightness(0.9);

    ${w}
    ${n("color", "dominantAlpha10")}

    &:hover,
    &:active {
      ${w}
      ${n("color", "dominantAlpha10")}
      filter: brightness(0.9);
    }

    ${k}
  `
}, fo = t`
  ${x("color, background-color, border-color, box-shadow, filter", T.shortest)}
  ${({ $fontFamily: o }) => F(E.action, o)}
  ${q}

  position: relative;
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: ${Y.sm};
  background-color: ${r.transparent};
  cursor: pointer;
  padding: ${a($.spacer3)} ${a($.spacer4)};
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  line-height: 1.5;
  white-space: nowrap;

  &:focus {
    outline: none;
  }

  [data-whatintent='keyboard'] &:focus-within {
    outline: 1px solid;
    ${n("outline-color", "dominant")};
    outline-offset: 4px;
  }

  ${({ $iconPosition: o }) => o === "right" && t`
      flex-direction: row-reverse;

      span {
        margin-right: ${a($.spacer2)};
      }

      div {
        margin-right: 0;

        div {
          span {
            margin-right: 0;
          }
        }
      }
    `}

  ${({ $fullWidth: o }) => o && t`
      width: 100%;
    `}

  ${d(
  h.xl,
  t`
      padding: ${a($.spacer2)} ${a($.spacer4)};
    `
)}

  ${({ $variant: o, $state: i }) => Ao({ variant: o, state: i })}

  &[href] {
    ${b(t`
      color: currentcolor;
    `)}
  }

  ${b(t`
    border: 1px solid currentcolor;
    color: WindowText;

    &:hover {
      color: WindowText;
      border: 1px solid currentcolor;
      ${n("background-color", "dominantAlpha80")}
    }
  `)}
`, yo = c.button`
  ${fo}
`, wo = t`
  ${Z};

  color: ${r.white};

  > span {
    margin-top: ${$.spacer4};

    ${d(
  h.md,
  t`
        margin-top: ${$.spacer5};
      `
)}
  }

  ${A} {
    border: 1px solid transparent;
    ${x("border, background", T.shortest)}
  }

  ::before {
    position: absolute;
    inset: 0;
    ${p("100%")};
    content: '';
  }

  :hover ${A} {
    border: 1px solid ${r.whiteAlpha80};
    background: ${r.greyAlpha40};
  }

  :active ${A} {
    border: 1px solid ${r.whiteAlpha60};
  }

  :focus ${A} {
    outline-offset: 8px;
    outline-color: ${r.white};
  }

  :disabled {
    border: none;
    color: ${r.whiteAlpha40};
  }

  > div {
    flex-shrink: 0;
    justify-content: center;
    margin-right: 0;
    border-radius: 50%;
    background: ${r.greyAlpha60};
    padding: ${a($.spacer3)};
    color: ${r.white};

    ${({ $size: o }) => t`
      ${p(o === "lg" ? 52 : 40)}
      ${d(h.md, p(o === "lg" ? 72 : 48))}
      ${o === "lg" && d(h.xl, p(144))}
      ${d(h.xxl, p(o === "lg" ? 180 : 96))}
    `}

    & svg {
      ${({ $size: o }) => t`
        ${p(o === "lg" ? 21 : 15)};
        ${d(h.md, p(o === "lg" ? 35 : 21))}
        ${o === "lg" && d(h.xl, p(78))}
        ${d(h.xxl, p(o === "lg" ? 98 : 35))}
      `}
    }
  }
`, Ao = ({ variant: o, state: i }) => {
  switch (o) {
    case "secondary":
      return uo[i || "active"];
    case "media-control":
      return wo;
    case "no-style":
      return bo[i || "active"];
    case "icon":
      return xo[i || "active"];
    case "inline":
      return vo[i || "active"];
    default:
      return go[i || "active"];
  }
}, ko = c.div`
  position: absolute;
  bottom: -0.7rem;
  left: 1rem;
  border-radius: ${a(12)};
  background-color: ${r.black};
  padding: 0 ${a($.spacer1)};
  min-width: ${a(18)};
  line-height: 1.5;
  color: ${r.white};
  font-size: ${a(12)};
`, jo = (o, i) => o ? "span" : i ? "a" : "button", So = ao(
  ({
    children: o,
    fake: i = !1,
    href: l,
    icon: s,
    theme: g,
    badgeValue: v,
    badgeAriaLabel: C,
    state: u,
    onClick: S,
    variant: P,
    fullWidth: H,
    size: M,
    dataQa: O,
    dataBadgeQa: R,
    ...V
  }, N) => {
    const U = io("font-family");
    if (typeof o > "u" && !s || !o && !s)
      return null;
    const L = jo(i, l), z = (m) => {
      if (u === "disabled" || u === "loading") {
        m.preventDefault(), m.stopPropagation();
        return;
      }
      S && S(m);
    }, G = () => {
      if (!v)
        return;
      const m = 99, J = v > m ? `${m}+` : v;
      return /* @__PURE__ */ e.jsxs(ko, { children: [
        /* @__PURE__ */ e.jsx("span", { "data-qa": R ?? "badge", children: J }),
        /* @__PURE__ */ e.jsx(Co, { className: "visually-hidden", children: C })
      ] });
    };
    return /* @__PURE__ */ e.jsx($o, { theme: g, children: /* @__PURE__ */ e.jsxs(
      yo,
      {
        ref: N,
        ...V,
        as: L,
        $iconPosition: s == null ? void 0 : s.position,
        $variant: P,
        $state: u,
        $fullWidth: H,
        $size: M,
        disabled: u === "disabled",
        onClick: (m) => z(m),
        ...l && { href: l },
        "data-qa": O ?? "button",
        $fontFamily: U,
        children: [
          /* @__PURE__ */ e.jsx(_o, { visible: u === "loading" }),
          s && /* @__PURE__ */ e.jsx(A, { children: /* @__PURE__ */ e.jsx(ho, { size: "xs", ...s, children: G() }) }),
          typeof o == "string" ? /* @__PURE__ */ e.jsx(mo, { children: o }) : o
        ]
      }
    ) });
  }
);
So.displayName = "Button";
const To = t`
  position: absolute !important;
  border: 0 !important;
  padding: 0 !important;
  width: 1px !important;
  height: 1px !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
`, Co = c.div`
  ${To}
`, Bo = no`
  0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
`, D = c.div`
  ${x("opacity")}

  position: absolute;
  inset: 0;
  opacity: ${({ $visible: o }) => o ? 1 : 0};
  z-index: ${I.base};
  margin: auto;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    border: ${a(1.5)} solid ${r.transparent};
    ${n("border-top-color", "dominant")};
    border-radius: 50%;
    animation: ${Bo} 1.9s ${eo} infinite;
  }

  &,
  & div {
    width: ${a(14)};
    height: ${a(14)};
    ${b(t`
      border-left: none;
      border-right: none;
      border-top: none;
    `)}
  }

  div:nth-child(1) {
    animation-delay: -0.45s;
  }

  div:nth-child(2) {
    animation-delay: -0.3s;
  }

  div:nth-child(3) {
    animation-delay: -0.15s;
  }
`, Wo = c.div`
  ${x("opacity")}

  position: absolute;
  opacity: ${({ $visible: o }) => o ? 0.8 : 0};
  z-index: ${I.base};
  background: ${r.white};
  pointer-events: unset;
  inset: 0;
`, _o = ({ hasOverlay: o = !1, visible: i = !1 }) => {
  const [l, s, g] = so(i, ["opacity"]);
  return !l && !s || !i ? null : o ? /* @__PURE__ */ e.jsx(Wo, { $visible: s, "data-qa": "spinner-overlay", children: /* @__PURE__ */ e.jsxs(D, { $visible: s, onTransitionEnd: g, children: [
    /* @__PURE__ */ e.jsx("div", {}),
    /* @__PURE__ */ e.jsx("div", {}),
    /* @__PURE__ */ e.jsx("div", {}),
    /* @__PURE__ */ e.jsx("div", {})
  ] }) }) : /* @__PURE__ */ e.jsxs(D, { $visible: s, onTransitionEnd: g, "data-qa": "spinner", children: [
    /* @__PURE__ */ e.jsx("div", {}),
    /* @__PURE__ */ e.jsx("div", {}),
    /* @__PURE__ */ e.jsx("div", {}),
    /* @__PURE__ */ e.jsx("div", {})
  ] });
};
export {
  So as B,
  ho as I,
  _o as S,
  $o as T,
  Co as V,
  fo as b,
  To as v
};
